import { Badge } from "../../components/badge";
import { DangerButton } from "../../components/button";
import { Icon } from "../../components/icon";
import { showFlyout } from "../../ui/flyout";
import { formatDuration } from "../../ui/format";
import { runOperation } from "../../ui/operation";
import { Paragraph } from "../../components/text";
import { DestructiveButton } from "../../components/destructive-button";

export const BatchItemStates = [
    { value: "", text: "All states" },
    {
        label: "Queue",
        items: [
            { value: "Pending", text: "Pending" }
        ]
    },
    {
        label: "Completed",
        items: [
            { value: "Finished", text: "Successful items" }
        ]
    },
    {
        label: "Confidence",
        items: [
            { value: "confidence:high", text: "High confidence (>=80%)" },
            { value: "confidence:low", text: "Low confidence (<30%)" }
        ]
    },
    {
        label: "Failures",
        items: [
            { value: "Refused", text: "Refused" },
            { value: "ExecutionError", text: "Execution error" },
            { value: "ValidationError", text: "Validation error" },
            { value: "Cancelled", text: "Cancelled" }
        ]
    }
];

export const BuiltinTools = [
    { value: "DateTime", label: "Current date and time", icon: "time-line" },
    { value: "OpenUrl", label: "Open URLs", icon: "link" },
    { value: "WebSearch", label: "Web search", icon: "search-line" },
    { value: "XPostsSearch", label: "X posts search", icon: "twitter-x-line" },
    { value: "AdvancedWebUsage", label: "Advanced web usage", icon: "drag-drop-line" },
    { value: "Code", label: "Code execution", icon: "braces-line" },
    { value: "ImageGeneration", label: "Image generation", icon: "image-ai-line" },
    { value: "Remember", label: "Memory", icon: "brain-2-line" }
];

export const DefaultWorkflowOptions = {
    title: "",
    instruction: "",
    resultSchema: {
        type: "object",
        properties: {},
        additionalProperties: true
    },
    validationInstruction: null,
    enabledTools: {
        enabledFunctions: [],
        options: {
            webSearchMode: "Summarized",
            webSearchMaxResults: 10,
            imageGenerationQuality: "Medium",
            imageGenerationMaxResults: 2,
            imageGenerationAllowMatureContent: false
        }
    },
    modelName: "@xiaomi/mimo-v2.5",
    reasoningEffort: null,
    errorStopThreshold: 5,
    maxRetries: 2
};

export function runtimeLabel(summary) {
    const state = Array.isArray(summary?.state) ? summary.state[0] : summary?.state;
    if (!summary?.restartedAt || state !== "Active")
        return "-";

    const seconds = Math.max(0, (Date.now() - new Date(summary.restartedAt).getTime()) / 1000);
    return formatDuration(seconds);
}

export function StateBadge(value) {
    const state = Array.isArray(value) ? value[0] : value || "-";
    const colors = {
        Active: "#1a7f37",
        Processing: "#1a7f37",
        Paused: "#9a6700",
        Pending: "#59636e",
        Queued: "#59636e",
        Finished: "#1a7f37",
        Completed: "#1a7f37",
        Refused: "#8250df",
        ExecutionError: "#cf222e",
        ValidationError: "#bf8700",
        Failed: "#cf222e",
        Cancelled: "#6e7781"
    };

    return Badge(state, colors[state]);
}

export function confirmDanger({ message, buttonText, operationText, onConfirm, delayAmount }) {
    showFlyout(
        Paragraph(message),
        DestructiveButton(Icon("delete-bin-line"), buttonText, {
            delayAmount,
            onDestruct(event) {
                runOperation(operationText, async () => {
                    await onConfirm();
                    event.target.closest(".flyout").hidePopover();
                });
            }
        })
    );
}
